import React, { Component } from "react";
import axios from "axios";
import { Image } from "pixboost-react";
import { Button } from "reactstrap";
import pixboostConfig from "../../config/pixboost";
import "./ProductTile.scss";
import { dispatchAnalyticsEvent } from "../analytics/analytics-context";

let miniCartControl;

class ProductTile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  triggerAddToCartAnalytics(sku) {
    dispatchAnalyticsEvent(document, "add-to-cart-fra", {
      addToCart: {
        cartAddLocation: "pens-stand", // eVar36
        events: "scAdd",
        product: [
          {
            productInfo: {
              productID: sku,
              qty: 1,
            },
            attributes: {},
          },
        ],
      },
    });
  }

  addToCart(sku) {
    if (
      typeof window.ow !== "undefined" &&
      typeof window.ow.controls !== "undefined" &&
      typeof window.ow.controls.addtocartcontrol !== "undefined" &&
      typeof miniCartControl === "undefined"
    ) {
      miniCartControl = new window.ow.controls.addtocartcontrol({
        el: document.documentElement,
      });
    }
    axios
      .get(
        `/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemAdd?nc=true&partNumber_1=${sku}&quantity_1=1`
      )
      .then(() => {
        if (typeof miniCartControl !== "undefined") {
          miniCartControl.updateMiniCart();
        }
        const addtocartcontrol = new window.ow.controls.addtocartcontrol();
        addtocartcontrol.updateMiniCart();
        if (typeof window.$ === "function") {
          window.$(document).trigger("alert", {
            type: "success",
            html: "<strong>Item added to cart</strong>",
            dismissible: true,
            scrollTo: false,
            trackState: false,
            floating: true,
            timeout: 3000,
            insert: {
              method: "prependTo",
              selector: "main",
            },
          });

          this.triggerAddToCartAnalytics(sku);
        }
      })
      .catch((err) => {
        console.log("Error adding to cart", err);
      });
  }

  render() {
    const { name, image, price, sku, available } = this.props;

    return (
      <div className={"ow-product-tile"}>
        <div className="ow-product-tile__inner">
          <a
            className="ow-product-tile__image-link"
            href={`/shop/officeworks/p/-${sku}`}
            title={name}
            target="_blank"
            rel="noopener noreferrer"
          >
            {image && <Image
              op={"resize?size=190"}
              src={image}
              alt={name}
              config={pixboostConfig}
            />
            }
          </a>
        </div>
        <div className="ow-product-tile__inner">
          <div className={"ow-price ow-price--small"}>
            <span className="ow-price__amount">${price / 100}</span>
          </div>
          <h5><a href={`/shop/officeworks/p/-${sku}`} title={name} target="_blank" rel="noopener noreferrer">{name}</a></h5>
          {available && 
            <Button className={"btn btn-success ow-add-to-cart btn-block"} onClick={() => this.addToCart(sku)}>
              <span>Add to Cart</span>
            </Button>
          }
          {!available && 
            <Button className="btn btn-success ow-add-to-cart " disabled={true}>
              <span>Unavailable Online</span>
            </Button>
          }
        </div>
      </div>
    );
  }
}

export default ProductTile;
